import { TwoPartiesPeriodSummaryBusinessCreationPayload } from '../../../../../../backend/src/services/resources/period-summaries/two-parties.period-summaries.business.service.types'
import { getDocIdAsString } from '../../../../utils/documents'
import { CounterFormValues, CountersData } from './types'

/**
 * Calculates counter parameters based on form values and counter data
 * @param formValues - Current form values for counters
 * @param counters - Counter data from simulation
 * @returns Array of counter parameters for API calls
 */
export const calculateCounterParams = (
  formValues: CounterFormValues,
  counters: CountersData,
): TwoPartiesPeriodSummaryBusinessCreationPayload['counters'] => {
  return Object.entries(formValues.counters).map(([counterId, counter]) => {
    // Calcul de l'adjustment selon le mode choisi
    let adjustment = 0
    const calculatedHours = counters[counterId]?.ruleBasedIncrement || 0

    switch (counter.mode) {
      case 'toCounter':
        // Tout vers le compteur : on ajoute toute la durée calculée dans le compteur
        adjustment = calculatedHours
        break

      case 'toWeek':
        // Tout dans la semaine : on n'ajoute rien dans le compteur
        // Si on récupère des heures depuis le compteur, on retire la durée récupérée du compteur
        adjustment = -(counter.recoveryFromCounter || 0)
        break

      case 'split':
        // Répartition partielle : on ajoute la partie qui va dans le compteur (splitToCounter)
        adjustment = counter.splitToCounter || 0
        break

      default:
        adjustment = 0
    }

    return {
      counterTemplateId: getDocIdAsString(counters[counterId]?.workerCounter?.template),
      adjustment,
    }
  })
}
